import GenericController from './../generic.controller'

export default class Controller extends GenericController {

    constructor(...args) {

        super(...args);

        this.isTroubled = true;
        this.busy = this.getZonesLoading = this.getOutputsLoading = true;
        this.setDefaultPolingTimer();
        this.getAllTroubles();

        this.$element.on('$destroy', () => {
            this.clearAllTimeouts();
        });
    }

    checkClearTimeout(pointedVariable) {
        this.$timeout.cancel(pointedVariable);
    }

    getAllTroubles() {
        this.getTroubles();
        this.getZonesTroubles();
        this.getOutputsTroubles();
        if (!this.isSerenityPanel()) {
            this.getKeypadsTroubles();
            this.getUsersTroubles();
        }
    }

    setDefaultPolingTimer() {
        this.polingTime = 2500;
    }

    increasePolingTimers(multiplication = 2) {
        this.polingTime *= multiplication;
    }

    setTimeoutGetTroubles() {
        this.timeoutGetTroubles = this.$timeout(this.getTroubles.bind(this), this.polingTime);
    }

    setTimeoutGetZonesTroubles() {
        this.timeoutGetZonesTroubles = this.$timeout(this.getZonesTroubles.bind(this), this.polingTime);
    }

    setTimeoutGetOutputsTroubles() {
        this.timeoutGetOutputsTroubles = this.$timeout(this.getOutputsTroubles.bind(this), this.polingTime);
    }

    setTimeoutGetKeypadsTroubles() {
        this.timeoutGetKeypadsTroubles = this.$timeout(this.getKeypadsTroubles.bind(this), this.polingTime);
    }

    setTimeoutGetUsersTroubles() {
        this.timeoutGetUsersTroubles = this.$timeout(this.getUsersTroubles.bind(this), this.polingTime);
    }

    getTroubles() {

        super.getTroubles()
            .then((r) => {
                this.currentTroubles = _.merge(this.currentTroubles, r.data);
                this.adjustTroublesNames();
                this.setDefaultPolingTimer();
                this.busy = false;
                this.setTimeoutGetTroubles();
            })
            .catch(err => {
                if (err.status != 403) {
                    this.increasePolingTimers();
                    this.setTimeoutGetTroubles();
                } else {
                    this.clearAllTimeouts();
                }
                this.busy = false;
            });

    }

    getZonesTroubles() {

        super.getZonesConfigList()
            .then((r) => {
                this.zonesTroubles = r;
                this.getZonesLoading = false;
                this.setTimeoutGetZonesTroubles()
            })
            .catch(err => {
                if (err.status != 403) {
                    this.setTimeoutGetZonesTroubles()
                } else {
                    this.clearAllTimeouts();
                }
            })
            .finally(r => this.getZonesLoading = false);
    }

    getOutputsTroubles() {

        super.getOutputsConfigList()
            .then((r) => {
                this.outputsTroubles = r;
                this.getOutputsLoading = false;
                this.setTimeoutGetOutputsTroubles();
            })
            .catch(err => {
                if (err.status != 403) {
                    this.setTimeoutGetOutputsTroubles();
                } else {
                    this.clearAllTimeouts();
                }
            })
            .finally(r => this.getOutputsLoading = false);
    }

    getKeypadsTroubles() {

        super.getKeypadsConfigList()
            .then((r) => {
                this.keypadsTroubles = r;
                this.getKeypadsLoading = false;
                this.setTimeoutGetKeypadsTroubles();
            })
            .catch(err => {
                if (err.status != 403) {
                    this.setTimeoutGetKeypadsTroubles();
                } else {
                    this.clearAllTimeouts();
                }
            })
            .finally(r => this.getKeypadsLoading = false);
    }

    getUsersTroubles() {
        super.getUsers()
            .then((r) => {
                this.usersTroubles = r.data;
                this.getUsersLoading = false;
                this.setTimeoutGetUsersTroubles();
            })
            .catch(err => {
                if (err.status != 403) {
                    this.setTimeoutGetUsersTroubles();
                } else {
                    this.clearAllTimeouts();
                }
            })
            .finally(r => this.getUsersLoading = false);
    }

    clearAllTimeouts() {
        this.checkClearTimeout(this.timeoutGetTroubles);
        this.checkClearTimeout(this.timeoutGetZonesTroubles);
        this.checkClearTimeout(this.timeoutGetOutputsTroubles);
        this.checkClearTimeout(this.timeoutGetKeypadsTroubles);
        this.checkClearTimeout(this.timeoutGetUsersTroubles);
    }

    // --- LifeCycle hooks ---

    $onInit() {

    }

    $onChanges(changesObj) {
        /* $onChanges(changesObj) - Called whenever one-way bindings are updated.
         * The changesObj is a hash whose keys are the names of the bound properties that have changed,
         * and the values are an object of the form { currentValue, previousValue, isFirstChange() }.
         * Use this hook to trigger updates within a component such as
         * cloning the bound value to prevent accidental mutation of the outer value. */
    }

}



/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/troubles.component/controller.js
 **/